import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SystemSettings } from '../../../../core/state/system-settings.state';
import { createActionCreator, createBoundActionCreator, createType } from '../../../../shared/state/index.state';

/**
 * https://medium.com/frontend-fun/angular-ngrx-a-clean-and-clear-introduction-4ed61c89c1fc
 */

@Injectable()
export class AdminSystemSettingsActions {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              ACTION CREATORS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    static GET_SYSTEM_SETTINGS_FROM_ADMIN = createActionCreator<number>(createType('[Admin:System] Get System Settings'));
    static GET_SYSTEM_SETTINGS_SUCCESS_FROM_ADMIN = createActionCreator<SystemSettings>(createType('[Admin:System] Get System Settings Success'));
    static GET_SYSTEM_SETTINGS_FAIL = createActionCreator<any>(createType('[Admin:System] Get System Settings Failed'));
    static SAVE_SYSTEM_SETTINGS = createActionCreator<any>(createType('[Admin:System] Save System Settings'));
    static SAVE_SYSTEM_SETTINGS_SUCCESS = createActionCreator<SystemSettings>(createType('[Admin:System Settings] Save System Settings Success'));
    static SAVE_SYSTEM_SETTINGS_FAIL = createActionCreator<any>(createType('[Admin:System] Save System Settings Failed'));

    static MAKE_SYSTEM_SETTINGS_FORM_PRISTINE = createActionCreator<any>(createType('[Admin:System] Reset Dirty Form'));

    constructor(private store: Store<any>) {}

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              BOUND ACTIONS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    getSystemSettingsFromAdmin = createBoundActionCreator(AdminSystemSettingsActions.GET_SYSTEM_SETTINGS_FROM_ADMIN, this.store.dispatch.bind(this.store));
    saveSystemSettings = createBoundActionCreator(AdminSystemSettingsActions.SAVE_SYSTEM_SETTINGS, this.store.dispatch.bind(this.store));
    resetForm = createBoundActionCreator(AdminSystemSettingsActions.MAKE_SYSTEM_SETTINGS_FORM_PRISTINE, this.store.dispatch.bind(this.store));
}
